import { createSlice } from '@reduxjs/toolkit';

import SpecialCashbackRateRepository from '../../repositories/Admin/FastCash/SpecialCashbackRateRepository';
import { createRestSlice } from '../../utils/RestSlice';

const specialCashbackRateRestSlice = createRestSlice({
  resource: 'specialCashbackRate',
  repository: SpecialCashbackRateRepository,
  slices: ['createSpecialCashbackRate', 'deleteSpecialCashbackRate'],
});

const initialState = {
  ...specialCashbackRateRestSlice.initialState,
};

const specialCashbackRateSlice = createSlice({
  name: 'specialCashbackRate',
  initialState,
  reducers: {
    ...specialCashbackRateRestSlice.reducers,
  },
});

export default specialCashbackRateSlice.reducer;

export const specialCashbackRateRestHooks = specialCashbackRateRestSlice.hooks(
  specialCashbackRateSlice,
  ['admin', 'SpecialCashbackRateSlice']
);
